import React from "react";
import PropTypes from "prop-types";
import styles from "./submitButton.module.css";

const SubmitButton = ({ label, onClick, ...props }) => {
  return (
    <button
      className={styles.submitButton}
      onClick={() => (onClick ? onClick() : {})}
      {...props}
    >
      {label}
    </button>
  );
};

SubmitButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

export default SubmitButton;
